"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stateTypes = _interopRequireDefault(require("./stateTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getUpdatedFilterGroups = function getUpdatedFilterGroups(_ref) {
  var id = _ref.id,
    groupState = _ref.groupState,
    filters = _ref.filters;
  var byId = _objectSpread(_objectSpread({}, filters.groups.byId), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, filters.groups.byId[id]), {}, {
    state: groupState
  })));
  return _objectSpread(_objectSpread({}, filters), {}, {
    groups: _objectSpread(_objectSpread({}, filters.groups), {}, {
      byId: byId
    })
  });
};
var getUpdatedFilterItems = function getUpdatedFilterItems(_ref2) {
  var id = _ref2.id,
    itemState = _ref2.itemState,
    filters = _ref2.filters,
    startDate = _ref2.startDate,
    endDate = _ref2.endDate;
  var byId = filters.items.allIds.reduce(function (acc, itemId) {
    if (itemId === id) {
      acc[itemId] = _objectSpread(_objectSpread({}, filters.items.byId[id]), {}, {
        state: itemState
      });
      if (startDate) {
        acc[itemId] = _objectSpread(_objectSpread({}, acc[itemId]), {}, {
          startDate: startDate
        });
      }
      if (endDate) {
        acc[itemId] = _objectSpread(_objectSpread({}, acc[itemId]), {}, {
          endDate: endDate
        });
      }
    } else if (filters.items.byId[id].group === filters.items.byId[itemId].group) {
      acc[itemId] = _objectSpread(_objectSpread({}, filters.items.byId[itemId]), {}, {
        state: _stateTypes.default.FILTER_ITEM_DEFAULT,
        startDate: null,
        endDate: null
      });
    } else {
      acc[itemId] = filters.items.byId[itemId];
    }
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, filters), {}, {
    items: _objectSpread(_objectSpread({}, filters.items), {}, {
      byId: byId
    })
  });
};
var getUpdatedFilterItemOptions = function getUpdatedFilterItemOptions(_ref3) {
  var id = _ref3.id,
    itemOptionState = _ref3.itemOptionState,
    filters = _ref3.filters;
  var byId = filters.itemOptions.allIds.reduce(function (acc, itemId) {
    if (itemId === id) {
      acc[itemId] = _objectSpread(_objectSpread({}, filters.itemOptions.byId[id]), {}, {
        state: itemOptionState
      });
    } else if (filters.itemOptions.byId[id].group === filters.itemOptions.byId[itemId].group) {
      acc[itemId] = _objectSpread(_objectSpread({}, filters.itemOptions.byId[itemId]), {}, {
        state: _stateTypes.default.FILTER_ITEM_OPTION_DEFAULT
      });
    } else {
      acc[itemId] = filters.itemOptions.byId[itemId];
    }
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, filters), {}, {
    itemOptions: _objectSpread(_objectSpread({}, filters.itemOptions), {}, {
      byId: byId
    })
  });
};
var clearActiveFilterItems = function clearActiveFilterItems(_ref4) {
  var id = _ref4.id,
    filters = _ref4.filters;
  var byId = filters.items.allIds.reduce(function (acc, itemId) {
    if (filters.items.byId[itemId].group === id) {
      acc[itemId] = _objectSpread(_objectSpread({}, filters.items.byId[itemId]), {}, {
        state: _stateTypes.default.FILTER_ITEM_DEFAULT
      });
    } else {
      acc[itemId] = filters.items.byId[itemId];
    }
    acc[itemId] = _objectSpread(_objectSpread({}, acc[itemId]), {}, {
      startDate: null,
      endDate: null
    });
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, filters), {}, {
    items: _objectSpread(_objectSpread({}, filters.items), {}, {
      byId: byId
    })
  });
};
var getUpdatedFolderItems = function getUpdatedFolderItems(_ref5) {
  var id = _ref5.id,
    itemState = _ref5.itemState,
    folders = _ref5.folders;
  var byId = folders.items.allIds.reduce(function (acc, itemId) {
    if (itemId === id) {
      acc[itemId] = _objectSpread(_objectSpread({}, folders.items.byId[id]), {}, {
        state: itemState
      });
    } else if (folders.items.byId[id].group === folders.items.byId[itemId].group) {
      acc[itemId] = _objectSpread(_objectSpread({}, folders.items.byId[itemId]), {}, {
        state: _stateTypes.default.FOLDER_ITEM_DEFAULT
      });
    } else {
      acc[itemId] = folders.items.byId[itemId];
    }
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, folders), {}, {
    items: _objectSpread(_objectSpread({}, folders.items), {}, {
      byId: byId
    })
  });
};
var getUpdatedUserItems = function getUpdatedUserItems(_ref6) {
  var id = _ref6.id,
    itemState = _ref6.itemState,
    users = _ref6.users;
  var byId = users.items.allIds.reduce(function (acc, itemId) {
    if (itemId === id) {
      acc[itemId] = _objectSpread(_objectSpread({}, users.items.byId[id]), {}, {
        state: itemState
      });
    } else if (users.items.byId[id].group === users.items.byId[itemId].group) {
      acc[itemId] = _objectSpread(_objectSpread({}, users.items.byId[itemId]), {}, {
        state: _stateTypes.default.USER_ITEM_DEFAULT
      });
    } else {
      acc[itemId] = users.items.byId[itemId];
    }
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, users), {}, {
    items: _objectSpread(_objectSpread({}, users.items), {}, {
      byId: byId
    })
  });
};
var _default = {
  getUpdatedFilterGroups: getUpdatedFilterGroups,
  getUpdatedFilterItems: getUpdatedFilterItems,
  getUpdatedFilterItemOptions: getUpdatedFilterItemOptions,
  clearActiveFilterItems: clearActiveFilterItems,
  getUpdatedFolderItems: getUpdatedFolderItems,
  getUpdatedUserItems: getUpdatedUserItems
};
exports.default = _default;